import { createFileRoute, Outlet } from "@tanstack/react-router";
import z from "zod";
import { ticketQueryOptions } from "@/services/ticket";

/**
 * Thin Ticket entity layout — shared params / prefetch for drawer tabs and workspace.
 * Drawer chrome lives in the pathless `_drawer` layout; workspace is a sibling route.
 */
export const Route = createFileRoute(
	"/_authenticated/(web-app)/_web/web/$orgId/tickets/(ticket)/$ticketId",
)({
	component: TicketIdLayout,
	params: {
		parse: (params) => ({
			ticketId: z.string().parse(params.ticketId),
		}),
	},
	loader: async ({ context, params }) => {
		await context.queryClient.ensureQueryData(
			ticketQueryOptions.detail(params.ticketId, {
				organizationId: params.orgId,
			}),
		);
	},
});

function TicketIdLayout() {
	return <Outlet />;
}
